import fp from 'lodash/fp';

export const guidesByIdSelector = fp.compose(fp.get('GuidesID.data.users'));
export const guidesByIdStatusSelector = fp.compose(fp.get('GuidesID.guide_loading'));
export const guideByIdStatusSelector = fp.compose(fp.get('GuidesID.guide'));
